/**
 * @file index.ts
 *
 * @fileoverview This file contains the utility functions for the Blog component.
 */

const SUMMARY_WORD_LIMIT = 60;

/**
 * Splits the summary into words and returns the first 60 words.
 * @param {string} summary
 * @returns {string} The first 60 words of the summary.
 */
export function getReducedSummary(summary: string): string {
  const summaryWords = summary.split(' ');

  return summaryWords.length > SUMMARY_WORD_LIMIT
    ? `${summaryWords.slice(0, SUMMARY_WORD_LIMIT).join(' ')}...`
    : summary;
}
